import React from 'react';
import { Link } from 'react-router-dom';
import Banner from '../Common/Banner';
import Slider from 'react-slick';
import DocumentMeta from 'react-document-meta';

class Repair extends React.Component {
	render() {
		
		let settings = {
			dots: false,
			autoplay: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
		};

		// Service packages & prices provided by the client
		const servicePackages = [
			{
				badge: 'Hjul & Dæk',
				title: 'Udskiftning af slange',
				price: 199,
				priceSub: 'Inkl. ny slange & montering',
				desc: 'Har du fået en punktering? Vi udskifter den gamle slange med en ny, så din cykel hurtigt bliver klar til brug igen.',
				features: ['1 ny slange', 'Montering inkluderet', 'Hurtig udbedring mens du venter'],
			},
			{
				badge: 'Service',
				title: 'Serviceeftersyn',
				price: 250,
				priceSub: 'Gennemgang af vitale dele',
				desc: 'Trænger din cykel til et eftersyn? Vi kontrollerer cyklens vigtigste dele og ser efter eventuelle problemer, så du kan cykle trygt i hverdagen.',
				features: ['Kontrol af bremser og gear', 'Kontrol af dæk og hjul', 'Kontrol af cyklens generelle tilstand'],
			},
						{
				badge: 'Hjul & Dæk',
				title: 'Nyt dæk og ny slange – inkl. montering',
				price: 499,
				priceSub: 'Inkl. montering på ét hjul',
				desc: 'Har du brug for et nyt dæk og en ny slange? Vi udskifter begge dele på ét hjul, så du hurtigt kan komme sikkert videre.',
				features: ['1 nyt dæk', '1 ny slange', 'Montering inkluderet', 'Gælder også elcykler'],
			}
		];

		const meta = {
			title: 			'Cykelservice og reparation hos Alaska Cykler',
			description: 	'Professionel cykelservice til gode priser – også til elcykler! Vi tilbyder cykelreparation, udskiftning af dæk og slanger samt serviceeftersyn til konkurrencedygtige priser. Besøg vores værksted i Brønshøj.',
			canonical: 		window.location.href,
			meta: {
				charset: 	'utf-8',
				name: {
					keywords: 'cykelservice brønshøj, cykelreparation, cykelværksted, serviceeftersyn cykel, udskiftning af slange, elcykel service'
				}
			}
	    };

		return (
			<div className="main-content" id="repair-page">
                
                <DocumentMeta {...meta} />

				<Banner 
					pageName='Værksted' 
					pageID='repair' 
					pageDesc='Professionel cykelservice til gode priser – også til elcykler!' 
					url='http://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,h_800,q_70/v1510589481/backgrounds/maxresdefault.jpg' />

				<div className="scroll-stop"></div>

				<div className="container">
					{/* Intro */}
					<header className="header header-main row">
						<h2 className="col-md-12">
							Cykelservice og reparation hos Alaska Cykler
							<p>Professionel cykelservice til gode priser – også til elcykler!</p>
						</h2>
					</header>

					<div className="row">
						<div className="col-md-10 col-md-offset-1">
							<div className="repair-intro">
								<p>Hos Alaska Cykler hjælper vi dig med at holde din cykel i god stand. Vi tilbyder cykelreparation, udskiftning af dæk og slanger samt serviceeftersyn til konkurrencedygtige priser.</p>
							</div>
						</div>
					</div>

					{/* Pricing Tier Cards */}
					<div className="row repair-pricing-row">
						{servicePackages.map((pkg, idx) => (
							<div className="col-xs-12 col-sm-4 col-md-4" key={idx}>
								<div className={pkg.featured ? 'repair-price-card featured' : 'repair-price-card'}>
									<div className="card-top-header">
										<div className={pkg.featured ? 'card-badge popular' : 'card-badge'}>
											{pkg.badge}
										</div>
										<h3 className="card-title">{pkg.title}</h3>
									</div>

									<div className="price-block">
										<div className="price">
											{pkg.price} <span className="currency">kr.</span>
										</div>
										<div className="price-sub">{pkg.priceSub}</div>
									</div>

									<p className="card-desc">{pkg.desc}</p>

									<div className="features-divider">
										<span>Inkluderet i pakken</span>
									</div>

									<ul className="tier-features">
										{pkg.features.map((feature, fIdx) => (
											<li key={fIdx}>
												<span className="check-icon"><i className="pe-7s-check" /></span>
												<span className="feature-text">{feature}</span>
											</li>
										))}
									</ul>

									<Link to="/contact" className={pkg.featured ? 'card-cta-btn featured' : 'card-cta-btn'}>
										<span>Bestil tid</span>
										<i className="pe-7s-angle-right" />
									</Link>
								</div>
							</div>
						))}
					</div>

					<div className="repair-parts-note">
						<div className="note-icon-wrap">
							<i className="pe-7s-info" />
						</div>
						<div className="note-text-wrap">
							<strong>Gennemskuelige priser:</strong> Eventuelle reservedele og ekstra reparationer aftales altid med kunden, inden arbejdet udføres.
						</div>
						<div className="note-badges">
							<span className="badge-item"><i className="pe-7s-check" /> Ingen skjulte gebyrer</span>
							<span className="badge-item"><i className="pe-7s-check" /> Gælder også elcykler</span>
						</div>
					</div>

					{/* Redesigned 100% Width Workshop Showcase Section */}
					<div className="row workshop-showcase-row">
						<div className="col-md-12 col-sm-12">
							<div className="workshop-showcase-card">
								<div className="workshop-gallery-card">
									<Slider {...settings} className="service-slider">									
										<div className="image-slider">
											<div className="inner">
												<img src="https://res.cloudinary.com/dttrnjoc5/image/upload/w_1200,q_90/v1509205791/services/22851380_10214552116380408_1479768585_o.jpg" alt="Alaska Cykler Værksted 1" />					
											</div>
										</div>
										<div className="image-slider">
											<div className="inner">
												<img src="https://res.cloudinary.com/dttrnjoc5/image/upload/w_1200,q_90/v1509205791/services/22883905_10214552115820394_523012815_o.jpg" alt="Alaska Cykler Værksted 2" />					
											</div>
										</div>
										<div className="image-slider">
											<div className="inner">
												<img src="https://res.cloudinary.com/dttrnjoc5/image/upload/w_1200,q_90/v1509205791/services/22878997_10214552117260430_2147055083_o.jpg" alt="Alaska Cykler Værksted 3" />					
											</div>
										</div>
									</Slider>
									<div className="workshop-location-pill">
										<span className="pe-7s-map-marker" /> Islevhusvej 7 · Ved Husum Torv
									</div>
								</div>

								<div className="workshop-info-card">
									<div className="workshop-info-header">
										<div className="workshop-info-text">
											<span className="section-overline">MODERNE CYKELVÆRKSTED</span>
											<h3>Mere end 15 års erfaring i vores moderne værksted</h3>
											<p>
												Vi tilbyder en lang række reparationer i vores moderne værksted, hvor dine brugte cykler kan repareres, lappes og efterses af vores erfarne medarbejdere, nemt og bekvemt. Vi har et bredt udvalg af reservedele og mere end 15 års erfaring.
											</p>
										</div>
										<div className="workshop-cta">
											<Link to="/contact" className="btn btn-primary">Kontakt Værkstedet</Link>
											<Link to="/rent-a-cycle" className="btn btn-default">Lej Lånecykel</Link>
										</div>
									</div>

									<div className="workshop-perks">
										<div className="perk-item">
											<span className="perk-icon"><i className="pe-7s-tools" /></span>
											<div className="perk-text">
												<h4>Alle former for reparationer</h4>
												<p>I vores værksted tilbyder vi alle former for reparationer, lapning og eftersyn af din cykel.</p>
											</div>
										</div>
										<div className="perk-item">
											<span className="perk-icon"><i className="pe-7s-clock" /></span>
											<div className="perk-text">
												<h4>Reparation mens du venter</h4>
												<p>Til din fordel kan vi ofte udbedre punkteringer og fejl på hjul og dæk, mens du venter.</p>
											</div>
										</div>
										<div className="perk-item">
											<span className="perk-icon"><i className="pe-7s-shield" /></span>
											<div className="perk-text">
												<h4>Bred vifte af reservedele</h4>
												<p>Vi udvælger vores sortiment med omhu og tester produkterne, så du kan føle dig helt tryg.</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>
		);
	}
}

export default Repair;



// WEBPACK FOOTER //
// ./src/Pages/Repair.js